// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "6edf0643" + "." + "ebeb43571e1bc1f6" + ".js";
};